import type { Xinglet } from '@xing-com/crate-xinglet';

import { KarriereMainEntry } from './karriere-main-entry';

export default class MainEntry implements Xinglet {
  public getComponent() {
    return (): JSX.Element => <KarriereMainEntry />;
  }
}
